/* eslint-disable new-cap */
/* eslint-disable no-empty-function */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable import/prefer-default-export */
import domains from '../containers/Domains';

class apiBuilder {
  /* The key must not have / on both ends.

       *** NOTE ***
       if the path contains parameter in the url in the form of {param},
       this will be removed including / at at both ends and will be replaced with one /
       if it needs to be.

       Assumption is that there is no consecutive parameters in operation. ex) preview/{id}/{contentID}
       ex) preview/{id} -> preview
           preview/{id}/content -> preview/content

    */
  pathToPort = {
    // alexiaops
    graphql: 5000,

    // alexia-core-api
    'service/ads': 5555,
    'service/ad/import': 5555,
    'service/ad/templates': 5555,
    'service/ad/templates/copy': 5555,
    'service/user/preferences': 5555,
    'service/carousel/carousels': 5555,
    'service/carousel/carousel': 5555,
    'service/carousel/carouselCard': 5555,
    'service/note': 5555,
    'service/note/hold': 5555,
    'service/adqc': 5555,
    'service/adqc/hold': 5555,
    'service/report': 5555,
    'service/asset/asset': 5555,
    'service/asset': 5555,
    'service/asset/thumbnail': 5555,
    'service/asset/archive': 5555,
    'service/assets': 5555,
    'service/asset/tags': 5555,
    'service/insights/iframe': 5555,
    'service/insights/iframes': 5555,
    'service/tags': 5555,
    'service/tags/tag': 5555,
    'service/tags/tags': 5555,
    'service/tags/category': 5555,
    'service/tags/categories': 5555,
    'service/asset/uploadedBy/all': 5555,
    'service/tags/asset': 5555,
    'service/tags/dashboard': 5555,
    'service/tags/dashboards': 5555,
    'service/utmprofile/utmprofile': 5555,
    'service/utmprofile/utmprofiles': 5555,
    'service/tags/all': 5555,
    'service/tags/list': 5555,
    'service/tags/name': 5555,
    'service/presentations/presentations': 5555,
    'service/pdf/header': 5555,
    'service/pdf/detail': 5555,
    'service/accounts': 5555,
    'service/utm': 5555,
    'service/package/packages': 5555,
    'service/package/package': 5555,
    'service/dashboard/dashboards': 5555,
    'service/dashboard/dashboard': 5555,
    'service/dashboard/tags': 5555,
    'service/adprototype/adprototypes': 5555,
    'service/adprototype/adprototype': 5555,
    'service/adprototype/adprototypes/filter': 5555,
    'service/canvas/canvases': 5555,
    'service/canvas/canvas': 5555,
    'service/token': 5555,

    // alexia-lambda-functions
    // 'service/ads': 5600,
    'alexia-archive-presentations@placeholder': 5601,
    email: 5602,
    facebook: 5603,
    'image/ad': 5604,
    'image/ad-pdf': 5604,
    'image/allads': 5605,
    'image/generate-ss-pdf': 5605,
    instagram: 5606,
    'share/ad': 5607,
    metadata: 5608,
    'alexia-pdf-generation-process@placeholder': 5609,
    'generate-pdf': 5610,
    'export-pdf': 5610,
    preview: 5611,
    'token/public': 5611,
    'alexia-video-lambda@placeholder': 5612,
    'asset/upload/token': 5613,
    'asset/delete': 5613,
    'cleanup/accounts': 5614,
    'insights/iframe': 5615,
    'insights/accounts': 5615,
    'insights/filters': 5615,
    'user/users': 5616,
    'user/adduser': 5616,
    'user/user': 5616,
    'user/changestatus': 5616,
    'user/groups': 5616,
    'user/usergroup': 5616,
    'import/ad': 5617,
    'chromedata/images/vin': 5618,
    'chromedata/fields': 5618,
    fbhealth: 5620,
    canvasduplicate: 5621
  };

  constructor() {}

  /**
   * This function builds api url based on the environment that the app is running.
   * If the app is running on local environment, appropriate port must be attached to
   * the host url.
   * @param {string} operation Default to an empty string. Assumed to start without / in the beginning. This will be the path that comes after the host.
   *
   * returns an string url without / at the end.
   *
   * NOTE
   * if operation contains paramter placeholder like {id}, this will be removed.
   */
  buildApi = (operation = '') => {
    if (!domains.environment) {
      throw new Error('domains.environment must be defined.');
    }

    const environment = domains.environment.trim().toLowerCase();
    let host = '';

    switch (environment) {
      case 'local':
        host = 'http://localhost';
        break;
      case 'dev':
        host = 'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev';
        break;
      case 'stg':
        host = 'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/stg';
        break;
      case 'hot':
        host = 'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/hotfix';
        break;
      case 'prd':
        host = 'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod';
        break;
      default:
        host = 'http://localhost';
        break;
    }

    // if it is not local environment, return the built url.
    // if operation === '', there is no port number we can look for. return the built url.
    if (environment !== 'local' || operation === '') {
      return `${host}/${operation}`;
    }

    // remove / at the end of the host.
    if (host[host.length - 1] === '/') host = host.substr(0, host.length - 1);

    // remove {<param>} or ?{<param>} or /{param} or ?{param}/from the operation and replace it with /
    // if / is attched at either end, remove them as well.
    const regex = /(\?*(\{\w+\}\/*)|\/*(\{\w+\}\/*)|\?+)/g;
    operation = operation.replace(regex, '/');
    operation = this.removeSlashOnEnds(operation);

    const port = this.pathToPort[operation];
    const portNumberString = port ? `:${port}` : '';

    return `${host}${portNumberString}/${operation}`;
  };

  removeSlashOnEnds = (text) => {
    const textLength = text.length;
    // sometimes, the operation is passed with / either at the beginning of the string or/and at the end of the string.
    // to be consistence, remove / on both sides.
    const textWithoutSlash = text
      .split('')
      .filter((char, index) => {
        if (index == 0 || index == textLength - 1) {
          return char !== '/';
        }

        return true;
      })
      .join('');

    return textWithoutSlash;
  };
}

export const api = new apiBuilder();



// WEBPACK FOOTER //
// ./src/utils/apiBuilder.js